import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StartComponent } from "./start/start.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../services/authgaurd.service";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { onlyFirstWordPipe } from "../shared/pipe/onlyFirstWordCapital.pipe";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { RegisterComponent } from "./sidenav/register/register.component";
import { CartlengthService } from "../services/cartlength.service";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SharedModule } from "../shared/shared.module";
import { AddCreditCardComponent } from "./sidenav/add-credit-card/add-credit-card.component";
import { NgxFastMarqueeModule } from "ngx-fast-marquee";
import { Notfound4o4Component } from './notfound4o4/notfound4o4.component';
import { ProductResolver } from "../resolver/product.resolver";

const routes: Routes = [
  {
    path: "",
    component: StartComponent,
    // canActivate:[AgeGuard],
    children: [
      {
        path: "",
        loadChildren: () => import("../pages/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "about-us",
        loadChildren: () => import("../pages/about-us/about-us.module").then((m) => m.AboutUsModule),
      },
      {
        path: "faq",
        loadChildren: () => import("../pages/faq/faq.module").then((m) => m.FaqModule),
      },
      {
        path: "how-to-order",
        loadChildren: () => import("../pages/howtoorder/howtoorder.module").then((m) => m.HowtoorderModule),
      },
      {
        path: "contact-us",
        loadChildren: () => import("../pages/contact-us/contact-us.module").then((m) => m.ContactUsModule),
      },
    
      {
        path: "return-exchange",
        loadChildren: () => import("../pages/return-exchange/return-exchange.module").then((m) => m.ReturnExchangeModule),
      },
      {
        path: "discountpolicy",
        loadChildren: () => import("../pages/termsandcondition/termsandcondition.module").then((m) => m.TermsandconditionModule),
      },
      {
        path: "privacypolicy",
        loadChildren: () => import("../pages/privacypolicy/privacypolicy.module").then((m) => m.PrivacypolicyModule),
      },
      {
        path: "login",
        loadChildren: () => import("../pages/login/login.module").then((m) => m.LoginModule),
      },
      {
        path: "register",
        loadChildren: () => import("../pages/register/register.module").then((m) => m.RegisterModule),
        canActivate: [AuthGuard],
      },
      {
        path: "mobile-verify",
        loadChildren: () => import("../pages/mobile-verify/mobile-verify.module").then((m) => m.MobileVerifyModule),
      },
      {
        path: "upload-id",
        loadChildren: () => import("../pages/upload-id/upload-id.module").then((m) => m.UploadIdModule),
      },
      {
        path: "shop",
        loadChildren: () => import("../pages/shop-page/shop/shop/shop.module").then((m) => m.ShopModule),
      },
      {
        path: "product-details/:CatalogItemId",
        loadChildren: () => import("../pages/product-details/product-details.module").then((m) => m.ProductDetailsModule),
        resolve: { product: ProductResolver }
      },
      {
        path: "brand",
        loadChildren: () => import("../pages/brands/brands.module").then((m) => m.BrandsModule),
      },
      {
        path: "order",
        loadChildren: () => import("../pages/order/order.module").then((m) => m.OrderModule),
      },
      {
        path: "dashboard",
        loadChildren: () => import("../pages/user-dashboard/user-dashboard.module").then((m) => m.UserDashboardModule),
      },
      {
        path: "forgot-password",
        loadChildren: () => import("../pages/forgot-password/forgot-password.module").then((m) => m.ForgotPasswordModule),
      },
      {
        path: "delivery-area",
        loadChildren: () => import("../pages/delivery-areas/delivery-areas.module").then((m) => m.DeliveryAreasModule),
      },
      {
        path: "how-to-shop",
        loadChildren: () => import("../pages/howtoorder/howtoorder.module").then((m) => m.HowtoorderModule),
      },
    
      {
        path: "local-delivery",
        loadChildren: () => import("../pages/local-delivery/local-delivery.module").then((m) => m.LocalDeliveryModule),
      },

      {
        path: "pickup-detail",
        loadChildren: () => import("../pages/pickup-detail/pickup-detail.module").then((m) => m.PickupDetailModule),
      },
   
      {
        path: "blogs",
        loadChildren: () => import("../pages/blogs/blogs.module").then((m) => m.BlogsModule),
      },
      {
        path: "weed-delivery/:key",
        loadChildren: () => import("../pages/weed-delivery/weed-delivery.module").then((m) => m.WeedDeliveryModule),
      },
      {
        path: "sitemap",
        loadChildren: () => import("../sitemap/sitemap/sitemap.module").then((m) => m.SitemapModule),
      },
      
    ],
  },

];


@NgModule({
  declarations: [StartComponent, HeaderComponent, FooterComponent, onlyFirstWordPipe, SidenavComponent, RegisterComponent,AddCreditCardComponent, Notfound4o4Component],
  imports: [
    CommonModule,
    CarouselModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatChipsModule,
    MatFormFieldModule,
    MatTooltipModule,
    SharedModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxFastMarqueeModule 
  ],
  providers: [CartlengthService],
})
export class StartModule {}
